import { render, staticRenderFns } from "./DialogEditUser.vue?vue&type=template&id=245d2e7c"
import script from "./DialogEditUser.vue?vue&type=script&lang=js"
export * from "./DialogEditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports